import {Controller} from "stimulus"

export default class extends Controller {
    //static targets = ['arrow', 'answer'];

    connect() {

   //     this.element.addEventListener('change', this.selectOnChange);
        this.element.addEventListener('click', this.selectOnChange);
    }

    selectOnChange(event) {

        let element = event.target;
        let sort_value = element.dataset.value;

        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set("sort_by", sort_value);
        window.location.search = searchParams.toString();
    }

}